import { RoleHost } from '../RoleHost';

export function STWrapper() {
  return <RoleHost role="st" />;
}
